var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"align"}},[_c('b-jumbotron',{attrs:{"id":"fundo"}},[_c('h1',{staticClass:"text-uppercase"},[_vm._v("to-do list")]),_c('p',[_vm._v("made by "),_c('a',{attrs:{"href":"https://elroydev.tech"}},[_vm._v("elroydevops")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }